import { Header } from '../../../components/header';
import { useTranslation } from 'react-i18next';
import { useState, useMemo } from 'react';
import Sidebar from '../../../components/Sidebar';
import TimesheetTabs from './components/TimesheetTabs';
import TimesheetCreation from './components/TimesheetCreation';
import TimesheetReports from './components/TimesheetReports';
import WorkedHours from './components/WorkedHours';
import './timeSheetsPage.scss';

function TimeSheetsPage() {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('creating-timesheet');

    const tabs = useMemo(() => [
        { key: 'creating-timesheet', label: t('CREATING_TIMESHEET') },
        { key: 'reports', label: t('REPORTS') },
        { key: 'worked-hours', label: t('WORKED_HOURS') }
    ], [t]);

    const renderContent = useMemo(() => {
        switch (activeTab) {
            case 'creating-timesheet':
                return <TimesheetCreation />;
            case 'reports':
                return <TimesheetReports />;
            case 'worked-hours':
                return <WorkedHours />;
            default:
                return <TimesheetCreation />;
        }
    }, [activeTab]);

    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='timesheets-invoice'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                <div className="dashboard-main-content">
                    <Header
                        setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className='timesheet-page-container'>
                        <TimesheetTabs 
                            tabs={tabs}
                            activeTab={activeTab}
                            onTabChange={setActiveTab}
                        />
                        <div className='timesheet-content'>
                            {renderContent}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TimeSheetsPage;
